"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgActionEdit01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "M3.835 24.154c.06-.551.092-.827.175-1.084q.112-.345.31-.647c.15-.226.346-.422.738-.815L22.667 4A3.771 3.771 0 0 1 28 9.333L10.392 26.942c-.393.392-.589.588-.815.737q-.302.2-.647.311c-.257.084-.533.114-1.084.175l-4.513.502z" }))); };
exports.default = SvgActionEdit01;
//# sourceMappingURL=ActionEdit01.js.map